module.exports = __webpack_public_path__ + "assets/img/group_1_3.69922b06.png";